import React from "react";
import styled, { keyframes } from "styled-components";
import NavbarList from "../NavbarList";
import LogoToggle from "../LogoToggle";
import NavbarComponent from "../NavbarComponent";
import { useSelectedTitleContext } from "../SelectedTitleContext";
import ExperienceFooter from "../ExperienceFooter";

const moveUp = keyframes`
from {
    opacity: 0;
    transform: translateX(100%);
  }

  to {
    opacity: 1;
    transform: translateX(0%);
  }
`;

const ContactUs = () => {
  const { isNavOpen, toggleNav, activeNavItem, handleNavItemChange, hostName } =
    useSelectedTitleContext();
  const handleloctionClick = () => {
    // Redirect to Google Maps with the specified coordinates
    window.location.href =
      "https://www.google.com/maps?q=28.41257547717772,77.05537609600638";
  };
  return (
    <>
      <LogoToggle isNavOpen={isNavOpen} toggleNav={toggleNav} />
      {isNavOpen && <NavbarComponent />}
      {!isNavOpen && (
        <>
          <Div>
            <div className="header">
              <h2> GET IN TOUCH!</h2>
              <p>Contact us for any query</p>
            </div>
            <div className="navbaropen">
              <div className="loction">
                <div>
                  <svg
                    onClick={handleloctionClick}
                    width="30%"
                    height="80%"
                    viewBox="0 0 109 102"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M93.6529 35.9125C88.8842 16.2775 70.5812 7.4375 54.5037 7.4375H54.4583C38.4262 7.4375 20.0779 16.235 15.3091 35.87C9.9954 57.8 24.3471 76.3725 37.3362 88.06C41.9402 92.23 48.0963 94.5618 54.5037 94.5625C60.6804 94.5625 66.8571 92.395 71.6258 88.06C84.615 76.3725 98.9667 57.8425 93.6529 35.9125ZM54.5037 57.205C52.625 57.205 50.7647 56.8587 49.029 56.1859C47.2933 55.5132 45.7161 54.527 44.3877 53.2839C43.0592 52.0407 42.0054 50.5649 41.2865 48.9407C40.5675 47.3164 40.1975 45.5756 40.1975 43.8175C40.1975 42.0594 40.5675 40.3186 41.2865 38.6943C42.0054 37.0701 43.0592 35.5943 44.3877 34.3511C45.7161 33.108 47.2933 32.1218 49.029 31.4491C50.7647 30.7763 52.625 30.43 54.5037 30.43C58.298 30.43 61.9368 31.8405 64.6198 34.3511C67.3027 36.8618 68.81 40.2669 68.81 43.8175C68.81 47.3681 67.3027 50.7732 64.6198 53.2839C61.9368 55.7945 58.298 57.205 54.5037 57.205Z"
                      fill="#1C1C1C"
                    />
                  </svg>
                </div>
                <div className="datadiv">
                  {" "}
                  2nd Floor, Supremework Hub, Eros City Square, Rosewood City,
                  Ghasola, Sector 49, Gurugram, Haryana 122018
                </div>
              </div>
              <div className="cll">
                {" "}
                <div>
                  <svg
                    width="30%"
                    height="80%"
                    viewBox="0 0 140 140"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M116.857 116.637H23.1445C18.2149 116.632 13.4889 114.671 10.0032 111.185C6.51741 107.699 4.55657 102.973 4.55078 98.0437V41.9562C4.55657 37.0266 6.51741 32.3006 10.0032 28.8149C13.4889 25.3291 18.2149 23.3683 23.1445 23.3625H116.857C121.787 23.3683 126.513 25.3291 129.998 28.8149C133.484 32.3006 135.445 37.0266 135.451 41.9562V98.0437C135.445 102.973 133.484 107.699 129.998 111.185C126.513 114.671 121.787 116.632 116.857 116.637ZM23.1445 29.925C19.9536 29.925 16.8934 31.1926 14.6372 33.4489C12.3809 35.7052 11.1133 38.7654 11.1133 41.9562V98.0437C11.1133 101.235 12.3809 104.295 14.6372 106.551C16.8934 108.807 19.9536 110.075 23.1445 110.075H116.857C120.048 110.075 123.108 108.807 125.364 106.551C127.621 104.295 128.888 101.235 128.888 98.0437V41.9562C128.888 38.7654 127.621 35.7052 125.364 33.4489C123.108 31.1926 120.048 29.925 116.857 29.925H23.1445Z"
                      fill="#1C1C1C"
                    />
                    <path
                      d="M70.001 83.3C65.9531 83.3064 62.0135 81.9931 58.7791 79.5594L7.70097 40.9281C7.34008 40.6748 7.03393 40.3514 6.80082 39.9772C6.56771 39.603 6.41241 39.1856 6.3442 38.75C6.27598 38.3144 6.29626 37.8695 6.40381 37.4419C6.51136 37.0144 6.70397 36.6128 6.97016 36.2614C7.23634 35.9099 7.57064 35.6156 7.95307 35.3962C8.3355 35.1768 8.75823 35.0367 9.196 34.9843C9.63378 34.9319 10.0776 34.9683 10.501 35.0913C10.9244 35.2142 11.3187 35.4213 11.6603 35.7L62.7385 74.375C64.836 75.9408 67.3834 76.7868 70.001 76.7868C72.6185 76.7868 75.1659 75.9408 77.2635 74.375L128.342 35.7C128.683 35.4213 129.077 35.2142 129.501 35.0913C129.924 34.9683 130.368 34.9319 130.806 34.9843C131.244 35.0367 131.666 35.1768 132.049 35.3962C132.431 35.6156 132.766 35.9099 133.032 36.2614C133.298 36.6128 133.491 37.0144 133.598 37.4419C133.706 37.8695 133.726 38.3144 133.658 38.75C133.59 39.1856 133.434 39.603 133.201 39.9772C132.968 40.3514 132.662 40.6748 132.301 40.9281L81.2228 79.5594C77.9884 81.9931 74.0488 83.3064 70.001 83.3Z"
                      fill="#1C1C1C"
                    />
                    <path
                      d="M9.12201 107.494C8.45651 107.495 7.80645 107.293 7.25808 106.916C6.70971 106.539 6.28895 106.004 6.05164 105.383C5.81433 104.761 5.77169 104.082 5.92937 103.435C6.08705 102.788 6.4376 102.205 6.93451 101.762L47.1845 65.8656C47.8343 65.2855 48.6879 64.9872 49.5576 65.0364C50.4273 65.0856 51.2419 65.4783 51.822 66.1281C52.4022 66.7779 52.7004 67.6315 52.6512 68.5012C52.602 69.3709 52.2093 70.1855 51.5595 70.7656L11.3095 106.662C10.7118 107.206 9.93008 107.503 9.12201 107.494ZM130.878 107.494C130.07 107.503 129.288 107.206 128.691 106.662L88.4408 70.7656C87.791 70.1855 87.3983 69.3709 87.3491 68.5012C87.2998 67.6315 87.5981 66.7779 88.1783 66.1281C88.7584 65.4783 89.5729 65.0856 90.4426 65.0364C91.3123 64.9872 92.166 65.2855 92.8158 65.8656L133.044 101.762C133.541 102.205 133.891 102.788 134.049 103.435C134.207 104.082 134.164 104.761 133.927 105.383C133.689 106.004 133.269 106.539 132.72 106.916C132.172 107.293 131.522 107.495 130.856 107.494H130.878Z"
                      fill="#1C1C1C"
                    />
                  </svg>
                </div>
                <div className="datadiv">
                  {" "}
                  {hostName === "Bluetick-VR"
                    ? "vishesh@bluetickvr.com"
                    : "hi@convrse.ai"}{" "}
                </div>
              </div>
              <div className="email">
                {" "}
                <div>
                  <svg
                    width="30%"
                    height="80%"
                    viewBox="0 0 107 107"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M89.166 42.5771C87.3381 42.5771 85.8223 41.0612 85.8223 39.2333V21.1771H67.766C65.9381 21.1771 64.4223 19.6612 64.4223 17.8333C64.4223 16.0054 65.9381 14.4896 67.766 14.4896H89.166C90.9939 14.4896 92.5098 16.0054 92.5098 17.8333V39.2333C92.5098 41.0612 90.9939 42.5771 89.166 42.5771ZM49.2639 66.6521L41.016 74.9C39.2773 76.6387 36.5131 76.6387 34.7298 74.9446C34.2393 74.4541 33.7489 74.0083 33.2585 73.5179C28.7501 68.9794 24.592 64.1058 20.8198 58.9392C17.1639 53.8567 14.2214 48.7742 12.0814 43.7362C9.98602 38.6537 8.91602 33.7942 8.91602 29.1575C8.91602 26.1258 9.45102 23.2279 10.521 20.5529C11.591 17.8333 13.2852 15.3367 15.6481 13.1075C18.5014 10.2987 21.6223 8.91666 24.9214 8.91666C26.1698 8.91666 27.4181 9.18416 28.5327 9.71916C29.6919 10.2542 30.7173 11.0567 31.5198 12.2158L41.8631 26.7946C42.6656 27.9092 43.2452 28.9346 43.6464 29.9154C44.0477 30.8517 44.2706 31.7879 44.2706 32.635C44.2706 33.705 43.9585 34.775 43.3344 35.8004C42.7548 36.8258 41.9077 37.8958 40.8377 38.9658L37.4493 42.4879C36.9589 42.9783 36.736 43.5579 36.736 44.2712C36.736 44.6279 36.7806 44.94 36.8698 45.2967C37.0035 45.6533 37.1373 45.9208 37.2264 46.1883C38.0289 47.6596 39.411 49.5767 41.3727 51.895C43.3789 54.2133 45.5189 56.5762 47.8373 58.9392C48.2831 59.385 48.7735 59.8308 49.2193 60.2767C51.0027 62.0154 51.0473 64.8687 49.2639 66.6521ZM97.9489 81.7212C97.943 83.4038 97.5623 85.0639 96.8344 86.5808C96.0764 88.1858 95.0956 89.7017 93.8027 91.1283C91.6181 93.5358 89.2106 95.2746 86.491 96.3892C86.4464 96.3892 86.4019 96.4337 86.3573 96.4337C83.7269 97.5037 80.8735 98.0833 77.7973 98.0833C73.2498 98.0833 68.3902 97.0133 63.2631 94.8287C58.136 92.6441 53.0089 89.7017 47.9264 86.0012C46.1877 84.7083 44.4489 83.4154 42.7994 82.0333L57.3781 67.4546C58.6264 68.3908 59.741 69.1041 60.6773 69.5946C60.9002 69.6837 61.1677 69.8175 61.4798 69.9512C61.8364 70.085 62.1931 70.1296 62.5943 70.1296C63.3523 70.1296 63.9319 69.8621 64.4223 69.3717L67.8106 66.0279C68.9252 64.9133 69.9952 64.0662 71.0206 63.5312C72.046 62.9071 73.0714 62.595 74.186 62.595C75.0331 62.595 75.9248 62.7733 76.9056 63.1746C77.8864 63.5758 78.9119 64.1554 80.0264 64.9133L94.7835 75.3904C95.9427 76.1929 96.7452 77.1292 97.2356 78.2437C97.6814 79.3583 97.9489 80.4729 97.9489 81.7212Z"
                      fill="#1C1C1C"
                    />
                  </svg>
                </div>
                <div className="datadiv">+ 91 8473994822</div>
              </div>
            </div>
            <div className="hand-images">
              <AnimatedImageLeft
                src="/hand-left.png"
                alt="hand-left"
                className="hand-left"
              />
              <AnimatedImageRight
                src="/hand-right.png"
                alt="hand-right"
                className="hand-right"
              />
            </div>
          </Div>
          <div className="footerr">
            <ExperienceFooter />
          </div>
        </>
      )}
    </>
  );
};

const moveUpDown = keyframes`
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-20px); /* Adjust the distance as needed */
  }
  100% {
    transform: translateY(0);
  }
`;

// Styled components for images
const AnimatedImageLeft = styled.img`
  animation: ${moveUpDown} 2s infinite; /* Adjust the animation duration as needed */
`;

const AnimatedImageRight = styled.img`
  animation: ${moveUpDown} 2s infinite; /* Adjust the animation duration as needed */
`;

const Div = styled.div`
  height: 85vh;
  animation: ${moveUp} 0.7s ease forwards;

  .header {
    width: 100%;
    text-align: center;
    h2 {
      font-size: 3.9rem;
      font-weight: 400;
      font-family: "Bebas Neue", sans-serif;
      margin-bottom: 0;
    }
    p {
      margin-top: 0;
      font-size: 1.2rem;
      font-family: "Poppins", sans-serif;
    }
  }
  .navbaropen {
    display: flex;

    cursor: pointer;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;

    .loction {
      text-align: center;
      width: 20vw;
      height: 30vh;
      cursor: pointer;
      border-right: 1px solid rgba(28, 28, 28, 1);

      .datadiv {
        margin-top: 8%;
        width: 90%;
      }
    }
    .cll {
      text-align: center;
      width: 20vw;
      height: 30vh;
      cursor: pointer;
      border-right: 1px solid rgba(28, 28, 28, 1);
      .datadiv {
        font-size: 1.2rem;
        margin-top: 8%;
      }
    }
    .email {
      text-align: center;
      width: 20vw;
      height: 30vh;
      cursor: pointer;
      .datadiv {
        font-size: 1.2rem;
        margin-top: 8%;
      }
    }
  }
  .hand-images {
    cursor: pointer;
    position: relative;
    display: flex;
    justify-content: space-between;
    margin-top: 5rem;
    align-items: center;
    gap: 70%;
    justify-content: center;
  }

  .hand-left,
  .hand-right {
    top: 0;
    bottom: 0;
    width: 10%;
    height: 45vh;
  }

  .hand-left {
    left: 2rem;
  }
  .img {
    width: 80%;
    margin-top: -5%;
    height: 100vh;
  }
  .hand-right {
    right: 2rem;
  }
  .footerr {
    display: flex;
    justify-content: flex-end;
  }
  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    height: 85vh;
    .header {
      width: 100%;
      text-align: center;
      h2 {
        font-size: 2rem;
      }
    }
    .navbaropen {
      display: flex;
      cursor: pointer;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 45%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 1;

      .loction {
        text-align: center;
        width: 20vw;
        height: 17vh;
        cursor: pointer;
        border-right: 1px solid rgba(28, 28, 28, 1);
        .datadiv {
          font-size: 0.9rem;
          text-align: left;
        }
      }
      .cll {
        text-align: center;
        width: 20vw;
        cursor: pointer;
        height: 17vh;
        border-right: 1px solid rgba(28, 28, 28, 1);
      }
      .email {
        text-align: center;
        width: 20vw;
        height: 17vh;
        cursor: pointer;
      }
    }
    .hand-images {
      cursor: pointer;
      position: relative;
      display: flex;
      justify-content: space-between;
      margin-top: 5rem;
      align-items: center;
      gap: 70%;
      justify-content: center;
    }

    .hand-left,
    .hand-right {
      top: 0;
      bottom: 0;
      width: 10%;
      height: 45vh;
    }

    .hand-left {
      left: 2rem;
    }
    .img {
      width: 80%;
      margin-top: -5%;
      height: 100vh;
    }
    .hand-right {
      right: 2rem;
    }
    .footerr {
      display: flex;
      justify-content: flex-end;
    }
  }
  @media only screen and (max-width: 767px) {
    height: 70vh;
    width: 140vw;
    .header {
      width: 100%;
      text-align: center;
      h2 {
        font-size: 2rem;
      }
    }
    .navbaropen {
      display: flex;
      cursor: pointer;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 35%;
      left: 51%;
      transform: translate(-50%, -50%);
      z-index: 1;

      .loction {
        text-align: center;
        width: 20vw;
        cursor: pointer;
        height: 13vh;
        font-size: 0.4rem;
        border-right: 0.6px solid rgba(28, 28, 28, 1);
      }
      .cll {
        text-align: center;
        width: 20vw;
        height: 10vh;
        padding: 1rem;
        cursor: pointer;
        font-size: 0.7rem;
        border-right: 0.6px solid rgba(28, 28, 28, 1);
        .datadiv {
          font-size: 0.5rem;
        }
      }
      .email {
        padding: 1rem;
        text-align: center;
        width: 20vw;
        height: 10vh;
        font-size: 0.5rem;
        cursor: pointer;
        .datadiv {
          font-size: 0.9rem;
        }
      }
    }
    .hand-images {
      cursor: pointer;
      position: relative;
      display: flex;
      justify-content: space-between;
      margin-top: 5rem;
      align-items: center;
      gap: 70%;
      justify-content: center;
    }

    .hand-left,
    .hand-right {
      top: 0;
      bottom: 0;
      width: 10%;
      height: 25vh;
    }

    .hand-left {
      left: 2rem;
    }
    .img {
      width: 80%;
      margin-top: -5%;
      height: 100vh;
    }
    .hand-right {
      right: 2rem;
    }
    .footerr {
      display: flex;
      justify-content: flex-end;
    }
  }
`;
export default ContactUs;
